export default {
    state: {
      terapiaNutricional:{
        
      },

      terapiaPsicologica:{
        
      }
    },
  
    mutations: {
      setTerapiaNutricional(state, newData) {
        state.terapiaNutricional= { ...state.terapiaNutricional, ...newData }
      },

      setTerapiaPsicologica(state, newData) {
        state.terapiaPsicologica= { ...state.terapiaPsicologica, ...newData }
      },
  
    },
  
  };